import { buildSelector } from '@/shared/lib/store';

export const [useViewerAvatar] = buildSelector(
    (state) => state.viewer?.data?.image || null,
);
